import App from "./app";
import Home from "./modules/home/home";
import About from "./modules/about/about";
import Visualize from "./modules/visualize/visualize";

export const routes = [
  {
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
        title: "Home",
        end: true,
      },
      {
        path: "/visualize/:id",
        element: <Visualize />,
        title: "Visualize",
        hide: true,
      },
      {
        path: "/visualize",
        element: <Visualize />,
        title: "Visualize",
        end: false,
      },
      {
        path: "/about",
        element: <About />,
        title: "About",
        end: true,
      },
      {
        path: "*",
        element: <div>Not Found</div>,
        hide: true,
      },
    ],
  },
];
